import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}

const initialState = {
  data: {
    productkeyworddata: {
      countryofimport: "US",
      keyword: "",
      matchtype: "contains",
      date: formatDate(new Date()),
      language: "EN",
      selectedCountry: {},
    },
    submitbutton: false,
    productkeywordresults: [],
    rulingdataresults: [],
    billofladingdataresults: [],
    productCountDetails: [],
  },
};

const productkeywordSlice = createSlice({
  name: "productkeyworddata",
  initialState,
  reducers: {
    storeProductKeywordData(state, action) {
      switch (action.payload.type) {
        case "country":
          state.data.productkeyworddata.countryofimport = action.payload.selectedvalue;
          break;
        case "selectedCountry":
          state.data.productkeyworddata.selectedCountry = action.payload.selectedvalue;
          break;
        case "product":
          state.data.productkeyworddata.keyword = action.payload.selectedvalue;
          break;

        case "matchtype":
          state.data.productkeyworddata.matchtype = action.payload.selectedvalue.value;
          break;

        case "date":
          state.data.productkeyworddata.date = moment(action.payload.value).format("YYYY-MM-DD");
          break;

        case "language":
          state.data.productkeyworddata.language = action.payload.selectedvalue;
          break;

        default:
          break;
      }
    },
    captureButtonClickProduct(state, action) {
      state.data.submitbutton = action.payload;
    },
    storeProductKeywordResults(state, action) {
      state.data.productkeywordresults = action.payload;
    },
    storeRulingDataResults(state, action) {
      state.data.rulingdataresults = action.payload;
    },
    storeBillOfLadingDataResults(state, action) {
      state.data.billofladingdataresults = action.payload;
    },
    storeProductCountDetails(state, action) {
      state.data.productCountDetails = action.payload;
    },
  },
});

export const { storeProductKeywordData, captureButtonClickProduct, storeProductKeywordResults, storeProductCountDetails, storeRulingDataResults, storeBillOfLadingDataResults } =
  productkeywordSlice.actions;

export default productkeywordSlice.reducer;
